export class TimeRangeModel {
  constructor(public fromTime: string, public toTime: string) {}
}
